<template>
  <main role="main" class="d-flex flex-column" style="min-height:100vh">

    <div style="flex:1 1 auto">
        <page-header></page-header>
        <div class="container my-5">
            <h4 class="mb-4">Numerical Blog for CAD EDA 3D and PCB manufacturing</h4>
            <b-embed
                type="iframe"
                aspect="1by1"
                src="https://www.numericalinnovations.com/blogs/news"
                allowfullscreen>
            </b-embed>
        </div>
        <page-footer></page-footer>
    </div>
  </main>
</template>

<script>
  import PageHeader from '../components/PageHeader.vue';
  import PageFooter from '../components/PageFooter.vue';

  export default {

    components: {PageHeader,PageFooter},

    mounted() {
      app = this;
      document.title = 'Blog';
    }

  }
</script>
